var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.style)},[_c('Wp_img_swipe',{attrs:{"title":_vm.title,"auto-play":_vm.auto_play,"round":_vm.round,"list":_vm.list},on:{"clickImage":_vm.clickActivesItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }